// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { infoCardsStyles } from "@turnerBlueprint/App/Widgets/InfoCards/InfoCards";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

infoCardsStyles.container = {
    css: css`
        padding-top: 0;
        gap: 22px 16px;
        display: flex;
        flex-wrap: wrap;
        @media print {
            page-break-inside: avoid;
        }
    `,
};
infoCardsStyles.content = {
    css: css`
        border: 1px solid ${color("common.border")};
        box-shadow: 0 2px 0 0 ${color("common.ui4")};
        background-color: ${color("common.white")};
        width: 100%;
        ${({ numberOfCards }: any) => {
            if (numberOfCards >= 3) {
                return css`
                    width: calc((100% - 32px) / 3);
                `;
                // eslint-disable-next-line no-else-return
            } else if (numberOfCards === 2) {
                return css`
                    width: calc((100% - 16px) / 2);
                `;
            }
        }};

        ${BLUEPRINT_NAME === "turnerBlueprint"
            ? css`
                  ${xScreen("lte", "md")} {
                      width: 100%;
                  }
              `
            : css`
                  ${xScreen("lte", "md")} {
                      width: calc((100% - 16px) / 2);

                      &:nth-of-type(n + 3) {
                          display: none;
                      }
                  }

                  ${xScreen("lt", "sm")} {
                      width: 100%;
                  }
              `}
    `,
};
